// TODO: [1] review use of peer dependencies vs dependencies
// TODO: [1] should we remove columns key from gridSetup (row currently isn't used). Validate by implementing heroes too
// TODO: [2] review prop types for all Cardo components and use shape where appropriate
// TODO: [3] Tests for helpers
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import R from 'ramda';
import CardoElement from '../shared/CardoElement';
import CardoContentWrapper from '../shared/CardoContentWrapper';
import CardoContent from '../shared/CardoContent';
import CardoImage from '../shared/CardoImage';
import CardoBody from '../shared/CardoBody';
import {
  isImageOffsetTop,
  isImageOffsetBottom,
  getBreakpointConfig,
  breakpointPropShape,
} from '../shared/helpers';

const generateCardoWrapperClassNames = ({
  xsmall,
  small,
  medium,
  large,
  xlarge,
}) => classNames(
  'cell',
  {
    [`xsmall-${R.path(['gridSetup', 'card', 'columns'], xsmall)}`]: R.path(['gridSetup', 'card', 'columns'], xsmall),
    [`small-${R.path(['gridSetup', 'card', 'columns'], small)}`]: R.path(['gridSetup', 'card', 'columns'], small),
    [`medium-${R.path(['gridSetup', 'card', 'columns'], medium)}`]: R.path(['gridSetup', 'card', 'columns'], medium),
    [`large-${R.path(['gridSetup', 'card', 'columns'], large)}`]: R.path(['gridSetup', 'card', 'columns'], large),
    [`xlarge-${R.path(['gridSetup', 'card', 'columns'], xlarge)}`]: R.path(['gridSetup', 'card', 'columns'], xlarge),
  },
);

const generateCardoImageWrapperClassNames = ({
  xsmall,
  small,
  medium,
  large,
  xlarge,
}) => classNames(
  'cell',
  {
    [`xsmall-${R.path(['gridSetup', 'image', 'columns'], xsmall)}`]: R.path(['gridSetup', 'image', 'columns'], xsmall),
    [`small-${R.path(['gridSetup', 'image', 'columns'], small)}`]: R.path(['gridSetup', 'image', 'columns'], small),
    [`medium-${R.path(['gridSetup', 'image', 'columns'], medium)}`]: R.path(['gridSetup', 'image', 'columns'], medium),
    [`large-${R.path(['gridSetup', 'image', 'columns'], large)}`]: R.path(['gridSetup', 'image', 'columns'], large),
    [`xlarge-${R.path(['gridSetup', 'image', 'columns'], xlarge)}`]: R.path(['gridSetup', 'image', 'columns'], xlarge),
  },
);

const generateCardoClassNames = ({
  currentBreakpoint,
  xsmall,
  small,
  medium,
  large,
  xlarge,
  extraClass,
}) => {
  const currentBreakpointConfig = getBreakpointConfig({
    currentBreakpoint,
    xsmall,
    small,
    medium,
    large,
    xlarge,
  });

  return classNames(
    'cardo',
    'grid-x',
    {
      'cardo--image-offset-top': isImageOffsetTop({ config: currentBreakpointConfig }),
      'cardo--image-offset-bottom': isImageOffsetBottom({ config: currentBreakpointConfig }),
      [extraClass]: extraClass,
    },
  );
};

const cardoBodyImage = ({
  currentBreakpoint,
  xsmall,
  small,
  medium,
  large,
  xlarge,
  data,
  fitImageToCard,
  zoomOnHover,
  shrinkOnHover,
  fixedHeight,
  doNotLazyLoad,
  imageDecode,
  disableProgressiveLoading,
}) => (
  <div
    className={generateCardoImageWrapperClassNames({
      currentBreakpoint,
      xsmall,
      small,
      medium,
      large,
      xlarge,
    })}
  >
    {
      R.isNil(R.prop('imageSrc')(data)) ? null :
      <CardoImage
        src={R.prop('imageSrc')(data)}
        srcset={R.prop('imageSrcSet')(data)}
        alt={R.prop('alt')(data)}
        url={R.path(['link', 'url'])(data)}
        linkText={R.path(['link', 'text'])(data)}
        cover={fitImageToCard}
        zoomOnHover={zoomOnHover}
        shrinkOnHover={shrinkOnHover}
        fixedHeight={fixedHeight}
        label={R.prop('label', data)}
        doNotLazyLoad={doNotLazyLoad}
        imageDecode={imageDecode}
        disableProgressiveLoading={disableProgressiveLoading}
      />
    }
  </div>
);

const cardoBodyContent = ({
  currentBreakpoint,
  xsmall,
  small,
  medium,
  large,
  xlarge,
  data,
  tagHeadingLevel,
  isTagUnderlined,
  hideDescription,
  hideContent,
  headingLevel,
  isTitleUnderlined,
  isSpanButton,
  imgRatingOnSrc,
  imgRatingOffSrc,
  ratingIconWidth,
  ratingIconHeight,
  showStarRating,
  showSwatches,
  moreVariantsIconSrc,
  contentTheme,
  onClick,
  index,
  productSwatch,
  originUrl,
  swatchLimit,
  openLinkInNewTab,
  fullClickableArea,
  renderCustomRating,
  additionalOnClick,
}) => {
  const CardoBodyContent = ({
    contentAlignment,
    contentOverlay,
    isContentFirst,
    imageColumns,
    contentColumns,
  }) => (
    <CardoContentWrapper
      contentAlignment={contentAlignment}
      contentOverlay={contentOverlay}
      isContentFirst={isContentFirst}
      currentBreakpoint={currentBreakpoint}
      xsmall={xsmall}
      small={small}
      medium={medium}
      large={large}
      xlarge={xlarge}
    >
      {!hideContent && (
        <CardoContent
          tag={R.prop('tag')(data)}
          tagHeadingLevel={tagHeadingLevel}
          isTagUnderlined={isTagUnderlined}
          description={R.prop('description')(data)}
          linkUrl={R.path(['link', 'url'])(data)}
          linkText={R.path(['link', 'text'])(data)}
          linkOpenInNewWindow={R.path(['link', 'openInNewWindow'])(data)}
          title={R.prop('title')(data)}
          hideDescription={hideDescription}
          headingLevel={headingLevel}
          isTitleUnderlined={isTitleUnderlined}
          isSpanButton={isSpanButton}
          averageRating={R.prop('averageRating', data)}
          numberOfReviews={R.prop('numberOfReviews', data)}
          imgRatingOnSrc={imgRatingOnSrc}
          imgRatingOffSrc={imgRatingOffSrc}
          ratingIconWidth={ratingIconWidth}
          ratingIconHeight={ratingIconHeight}
          showStarRating={showStarRating}
          swatches={showSwatches && productSwatch[R.prop('uid')(data)]}
          swatchLimit={swatchLimit}
          moreVariantsIconSrc={moreVariantsIconSrc}
          imageColumns={imageColumns}
          contentColumns={contentColumns}
          contentOverlay={contentOverlay}
          contentTheme={contentTheme}
          onClick={onClick}
          index={index}
          originUrl={originUrl}
          openLinkInNewTab={openLinkInNewTab}
          fullClickableArea={fullClickableArea}
          renderCustomRating={renderCustomRating}
          bvid={R.prop('bvid', data)}
          additionalOnClick={additionalOnClick}
          additionalButtonText={R.prop('additionalButtonText', data)}
        />
      )}
    </CardoContentWrapper>
  );

  CardoBodyContent.propTypes = {
    contentAlignment: PropTypes.objectOf(PropTypes.string).isRequired,
    contentOverlay: PropTypes.shape({
      coverImage: PropTypes.bool.isRequired,
      verticalOffsetType: PropTypes.string.isRequired,
      horizontalOffset: PropTypes.bool.isRequired,
      // TODO: [1] ^^ not currently used. Check if needed for cards or just hero
    }),
    isContentFirst: PropTypes.bool.isRequired,
    imageColumns: PropTypes.number.isRequired,
    contentColumns: PropTypes.number.isRequired,
  };

  return CardoBodyContent;
};

const Cardo = ({
  data,
  // Layout config
  currentBreakpoint,
  breakpointConfig: {
    xsmall,
    small,
    medium,
    large,
    xlarge,
  } = {},
  // Styles and generic config
  contentTheme = 'solid', // Note: was contentBoxTheme
  isTitleUnderlined = true,
  isSpanButton = false,
  tagHeadingLevel,
  isTagUnderlined = false,
  showStarRating = false,
  showSwatches = false,
  moreVariantsIconSrc,
  headingLevel,
  zoomOnHover = false,
  shrinkOnHover = false,
  imgRatingOnSrc,
  imgRatingOffSrc,
  ratingIconWidth,
  ratingIconHeight,
  fitImageToCard = true, // Note: was cover for previous Card
  fixedHeight = false,
  hideDescription = false,
  hideContent = false,
  onClick,
  extraClass,
  productSwatch,
  swatchLimit,
  originUrl,
  index = 0, // This is used by CardoGroup
  openLinkInNewTab = false,
  doNotLazyLoad,
  imageDecode,
  fullClickableArea = true,
  disableProgressiveLoading = false,
  renderCustomRating,
  additionalOnClick,
  cardoWrapperPropsBuilder, // Add custom attributes for HTML tag
  // Note: used in previous Card. No longer used and shouldn't be needed - keeping in temporarily for reference.
  // hasBackground = false,
  // isSmallTitle = true,
  // fullWidth = true,
  // cardsData,
  // fullWidthContent = false,
  // fillContainer = false,
  // noGutters = false,
  // isSmallWidthHalf,
  // contentBoxColumns,
  // alignCenter = true,
}) => (
  <div
    {...(cardoWrapperPropsBuilder ? cardoWrapperPropsBuilder({ index }) : {})}
    className={generateCardoWrapperClassNames({
      xsmall,
      small,
      medium,
      large,
      xlarge,
    })}
  >
    <CardoElement
      classNames={generateCardoClassNames({
        currentBreakpoint,
        xsmall,
        small,
        medium,
        large,
        xlarge,
        extraClass,
      })}
      linkUrl={R.path(['link', 'url'])(data)}
      linkOpenInNewWindow={R.path(['link', 'openInNewWindow'])(data)}
      accessibleLinkText={R.path(['link', 'accessibleText'])(data)}
      onClick={onClick}
      index={index}
      fullClickableArea={fullClickableArea}
      openLinkInNewTab={openLinkInNewTab}
      renderCustomRating={renderCustomRating}
    >
      <CardoBody
        image={cardoBodyImage({
          currentBreakpoint,
          xsmall,
          small,
          medium,
          large,
          xlarge,
          data,
          fitImageToCard,
          zoomOnHover,
          shrinkOnHover,
          fixedHeight,
          doNotLazyLoad,
          imageDecode,
          disableProgressiveLoading,
        })}
        content={cardoBodyContent({
          currentBreakpoint,
          xsmall,
          small,
          medium,
          large,
          xlarge,
          data,
          tagHeadingLevel,
          isTagUnderlined,
          hideDescription,
          hideContent,
          headingLevel,
          isTitleUnderlined,
          isSpanButton,
          imgRatingOnSrc,
          imgRatingOffSrc,
          ratingIconWidth,
          ratingIconHeight,
          showStarRating,
          showSwatches,
          moreVariantsIconSrc,
          contentTheme,
          onClick,
          index,
          productSwatch,
          originUrl,
          swatchLimit,
          openLinkInNewTab,
          fullClickableArea,
          renderCustomRating,
          additionalOnClick,
        })}
        xsmall={xsmall}
        small={small}
        medium={medium}
        large={large}
        xlarge={xlarge}
        currentBreakpoint={currentBreakpoint}
        extraClass={extraClass}
      />
    </CardoElement>
  </div>
);

Cardo.propTypes = {
  data: PropTypes.shape({
    tag: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    link: PropTypes.shape({
      text: PropTypes.string,
      url: PropTypes.string,
      openInNewWindow: PropTypes.bool,
    }).isRequired,
    label: PropTypes.string,
    averageRating: PropTypes.number,
    numberOfReviews: PropTypes.number,
    imageSrc: PropTypes.string.isRequired,
    imageSrcSet: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string.isRequired,
      src: PropTypes.string.isRequired,
    })),
    alt: PropTypes.string,
  }),
  // Layout config
  currentBreakpoint: PropTypes.string.isRequired,
  breakpointConfig: PropTypes.shape({
    xsmall: breakpointPropShape,
    small: breakpointPropShape,
    medium: breakpointPropShape,
    large: breakpointPropShape,
    xlarge: breakpointPropShape,
  }).isRequired,
  // Styles and generic config
  contentTheme: PropTypes.oneOf(['solid', 'alpha', 'transparent']),
  isTitleUnderlined: PropTypes.bool,
  isSpanButton: PropTypes.bool,
  tagHeadingLevel: PropTypes.number,
  isTagUnderlined: PropTypes.bool,
  showStarRating: PropTypes.bool,
  showSwatches: PropTypes.bool,
  moreVariantsIconSrc: PropTypes.string,
  headingLevel: PropTypes.number,
  zoomOnHover: PropTypes.bool,
  shrinkOnHover: PropTypes.bool,
  imgRatingOnSrc: PropTypes.string,
  imgRatingOffSrc: PropTypes.string,
  fitImageToCard: PropTypes.bool,
  fixedHeight: PropTypes.bool,
  hideDescription: PropTypes.bool,
  hideContent: PropTypes.bool,
  onClick: PropTypes.func,
  index: PropTypes.number,
  extraClass: PropTypes.string,
  productSwatch: PropTypes.arrayOf(PropTypes.array),
  swatchLimit: PropTypes.number,
  originUrl: PropTypes.string,
  openLinkInNewTab: PropTypes.bool,
  doNotLazyLoad: PropTypes.bool,
  imageDecode: PropTypes.string,
  fullClickableArea: PropTypes.bool,
  disableProgressiveLoading: PropTypes.bool,
  renderCustomRating: PropTypes.func,
  ratingIconWidth: PropTypes.number,
  ratingIconHeight: PropTypes.number,
};

// TODO: removed deepEqual as not recommended. Look into preventing re-renders in children caused by removal of check
export default React.memo(Cardo);
